var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gl-mt-6"},[(_vm.isLoading)?_c('div',{key:"_vif_1_0"},[_c('gl-skeleton-loader',{attrs:{"lines":1,"width":400}})],1):_c('div',{key:"_vif_1_1",staticClass:"gl-flex gl-items-center gl-gap-2"},[_c('h1',{staticClass:"gl-heading-1 gl-m-0"},[_vm._v(_vm._s(_vm.pageTitle))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }